import classNames from 'class-names';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import {
  AccordionContext,
  Accordion as BSAccordion,
  Card,
  Col,
  Row,
  useAccordionToggle,
} from 'react-bootstrap';

import Button from '../../Atoms/Button/Button';
import Icon from '../../Atoms/Icon/Icon';

import styles from './groups-accordion.module.css';

const CustomToggle = ({ eventKey, onExpand, groupName, onEdit, onDelete }) => {
  const decoratedOnClick = useAccordionToggle(eventKey, () =>
    onExpand ? onExpand(eventKey) : '',
  );
  const currentEventKey = useContext(AccordionContext);
  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <Row className="mx-0">
      <Col xs={8} md={10} className="pr-0 pl-0">
        <Button
          className={classNames(
            'btn-block text-left text-gray-dark pl-0 control-btn arrow-at-start',
            {
              open: !isCurrentEventKey,
            },
            !isCurrentEventKey ? 'bg-white' : 'bg-a-10-blue font-weight-bold',
          )}
          variant="link"
          onClick={decoratedOnClick}
          onKeyDown={decoratedOnClick}
          aria-hidden="true"
        >
          {groupName}
        </Button>
      </Col>
      <Col
        xs={4}
        md={2}
        className={classNames(
          'border-left d-flex justify-content-center py-1 bg-white',
          {},
        )}
      >
        <Button variant="link" title="Edit" onClick={() => onEdit(eventKey)}>
          <Icon
            name="pencil"
            className={classNames(styles.icon, 'text-gray')}
          />
        </Button>
        <Button
          variant="link"
          title="Delete"
          onClick={() => onDelete(eventKey)}
        >
          <Icon name="trash" className={classNames(styles.icon, 'text-gray')} />
        </Button>
      </Col>
    </Row>
  );
};
CustomToggle.propTypes = {
  eventKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  onExpand: PropTypes.func,
  groupName: PropTypes.string,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const GroupsAccordion = ({ platformGroups, onEdit, onDelete }) => {
  return (
    <BSAccordion>
      <Card className={styles.card}>
        {platformGroups.map(({ id, name, description }, index) => (
          <div key={id}>
            <Card.Header
              className={classNames(styles.cardHeader, {
                'border-top': index > 0,
              })}
            >
              <CustomToggle
                eventKey={id}
                groupName={name}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            </Card.Header>

            <BSAccordion.Collapse eventKey={id}>
              <Card.Body className={styles.descriptionGradient}>
                {description}
              </Card.Body>
            </BSAccordion.Collapse>
          </div>
        ))}
      </Card>
    </BSAccordion>
  );
};
GroupsAccordion.propTypes = {
  platformGroups: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
export default GroupsAccordion;
